import { useUserByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function ProfilListItem({userid}:{userid:string|number}){
    const {translate}=useTrads();
    const { data, error, isLoading }= useUserByIdQuery(userid.toString());
    return (
        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : data ? (
        <span>{data.nom?data.nom:data.identifiant}</span>
        ):null
    )
}
export default ProfilListItem;